import { Card, CardContent } from '@/components/ui/card';

export default function TermsOfService() {
  return (
    <div className="py-8 overflow-y-scroll">
      <div className="max-w-4xl mx-auto px-6">
        <Card className="bg-white shadow-sm">
          <CardContent className="p-8">
            {/* Header */}
            <div className="mb-8">
              <p className="text-sm text-gray-600 leading-relaxed">
                {`퀘스토피아(www.questophia.com)를 운영하는 주식회사 퀘스토피아(이하 "회사")는 다음과
                같은 원칙에 의하여 이용자의 개인정보를 수집, 이용 및 관리하고 있고, 이와 관련하여
                정보통신서비스 제공자가 준수하여야 하는 대한민국 관계법령 및 개인정보보호규정,
                가이드라인을 준수하고 있습니다.`}
              </p>
            </div>

            {/* Article 1 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 1조 개인정보 수집 항목 및 수집 방법
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 회원가입 시 원활한 고객상담, 각종 서비스의 제공을 위해 아래와 같은 최소한의
                개인정보를 필수항목으로 수집하고 있습니다.
              </p>

              <div className="overflow-x-auto mb-4">
                <table className="w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">
                        수집방법
                      </th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">
                        수집 및 이용항목
                      </th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">
                        이용, 보유기간
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">회원가입</td>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        이름, 이메일, 학교, 학과, 전화번호
                      </td>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        회원 탈퇴시까지
                      </td>
                    </tr>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        자동생성 및 수집
                      </td>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        서비스 이용과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수
                        있습니다.
                        <br />
                        서비스 이용기록, 접속 ID정보, 접속로그, 쿠키, 이벤트로그
                      </td>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        회원 탈퇴시까지
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    퀘스토피아 홈페이지를 통한 회원가입과정에서 해당 개인정보를 수집합니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    고객센터를 통한 상담과정에서 웹페이지, 메일, 전화 등을 통해 이용자의 개인정보가
                    수집될 수 있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>회원 탈퇴 신청 후 7일간의 유예기간을 두어, 7일 뒤 탈퇴 처리합니다.</span>
                </li>
              </ul>
            </section>

            {/* Article 2 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 2조 개인정보 수집의 목적
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 회원님의 개인정보를 다음과 같은 목적에 따라 이용하고 있습니다.
              </p>

              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-2">
                    1. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금 정산
                  </h3>
                  <ul className="ml-4">
                    <li className="flex items-start text-sm text-gray-600">
                      <span className="mr-2">-</span>
                      <span>
                        콘텐츠 제공, 서비스 구매 및 요금 결제, 금융거래 본인 인증 및 금융 서비스 등
                      </span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-2">2. 회원 관리</h3>
                  <ul className="ml-4">
                    <li className="flex items-start text-sm text-gray-600">
                      <span className="mr-2">-</span>
                      <span>
                        회원제 서비스에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가
                        사용 방지, 가입 의사 확인, 가입 및 가입횟수 제한, 분쟁 조정을 위한 기록
                        보존, 불만처리 등 민원 처리, 고지 사항 전달
                      </span>
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-sm font-medium text-gray-800 mb-2">
                    3. 신규 서비스 개발, 마케팅 및 광고에 활용
                  </h3>
                  <ul className="ml-4 space-y-2">
                    <li className="flex items-start text-sm text-gray-600">
                      <span className="mr-2">-</span>
                      <span>
                        신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적
                        특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스
                        이용에 대한 통계
                      </span>
                    </li>
                    <li className="flex items-start text-sm text-gray-600">
                      <span className="mr-2">-</span>
                      <span>
                        회원가입시 기재한 이메일 및 휴대폰 번호는 주요 공지사항, 신규 서비스 및
                        다양한 이벤트, 프로모션 정보를 제공하는 데 사용될 수 있습니다.
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            {/* Article 3 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 3조 개인정보 수집 동의
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                회원가입 시 회원님께서 충분히 개인정보취급방침을 확인할 수 있도록 표기하고, 동의한
                이후에 가입할 수 있도록 환경을 조성합니다. 회원가입을 완료한 모든 회원은 상기 모든
                개인정보 수집 절차 및 이용 목적에 동의한 것으로 간주합니다.
              </p>
            </section>

            {/* Article 4 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 4조 개인정보의 보유 및 이용 기간
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 법령에 따른 개인정보 보유이용기간 또는 정보주체로부터 개인정보를 수집 시에
                동의 받은 개인정보 보유, 이용기간 내에서 개인정보를 처리, 보유합니다. 구체적인
                개인정보 처리 및 보유 기간은 다음과 같습니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한
                    법률)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에
                    관한 법률)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    소비자의 불만 또는 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에
                    관한 법률)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    표시광고에 관한 기록: 6개월 (전자상거래 등에서의 소비자보호에 관한 법률)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>웹사이트 방문기록: 3개월 (통신비밀보호법)</span>
                </li>
              </ul>
            </section>

            {/* Article 5 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 5조 개인정보의 파기 절차 및 방법
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 개인정보의 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을
                때에는 지체없이 해당 개인정보를 파기합니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-3 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>파기절차:</strong> 회원가입 등을 위해 입력하신 정보는 목적이 달성된 후
                    내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 일정 기간 저장된 후
                    파기됩니다.
                  </span>
                </li>
                <li>
                  <span className="mr-2">-</span>
                  <span>
                    <strong>파기방법</strong>
                  </span>
                  <ul className="ml-6 mt-2 space-y-1">
                    <li className="flex items-start">
                      <span className="mr-2">-</span>
                      <span>
                        전자적 파일 형태의 정보는 기록을 재생할 수 없는 기술적 방법을 사용합니다.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2">-</span>
                      <span>
                        종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </section>

            {/* Article 6 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 6조 개인정보의 제3자 제공
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 귀하의 개인정보를 개인정보의 수집 및 이용목적에서 고지한 범위 내에서 사용하며
                원칙적으로 외부에 제공하지 않습니다. 단, 다음은 예외로 합니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>관계법령에 의하여 수사상의 목적으로 관계기관으로부터 요구가 있을 경우</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>기타 관계법령에서 정한 절차에 따른 요청이 있는 경우</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>이용자들이 사전에 동의한 경우</span>
                </li>
              </ul>
            </section>

            {/* Article 7 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 7조 개인정보 위탁
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 고객님의 동의 없이 고객님의 개인정보 취급을 외부업체에 위탁하지 않습니다.
                향후 그러한 필요가 생길 경우 위탁대상자와 위탁업무 내용에 대해 고객님께 통지하고
                필요한 경우 사전 동의를 받습니다.
              </p>

              <div className="overflow-x-auto">
                <table className="w-full border border-gray-300 text-sm">
                  <thead>
                    <tr className="bg-gray-50">
                      <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">
                        제공받는자
                      </th>
                      <th className="border border-gray-300 px-4 py-3 text-left font-medium text-gray-700">
                        위탁업무내용
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600"></td>
                      <td className="border border-gray-300 px-4 py-3 text-gray-600">
                        구매 및 요금결제(신용카드 등)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            {/* Article 8 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 8조 개인정보 자동 수집 장치의 설치운영 및 거부에 관한 사항
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                {`회사는 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는
                '쿠키(cookie)'를 사용합니다. 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가
                이용자의 컴퓨터 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 컴퓨터내의
                하드디스크에 저장되기도 합니다.`}
              </p>

              <ul className="text-sm text-gray-600 space-y-3 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>쿠키의 사용 목적:</strong> 고객이 방문한 각 서비스와 웹 사이트들에 대한
                    방문 및 이용형태, 인기 검색어, 보안접속 여부 등을 파악하여 이용자에게 최적화된
                    정보 제공을 위해 사용됩니다.
                  </span>
                </li>
                <li>
                  <span className="mr-2">-</span>
                  <span>
                    <strong>쿠키의 설치운영 및 거부</strong>
                  </span>
                  <ul className="ml-6 mt-2 space-y-1">
                    <li className="flex items-start">
                      <span className="mr-2">-</span>
                      <span>
                        <strong>Internet Explorer:</strong> 웹브라우저 상단의 도구 &gt; 인터넷 옵션
                        &gt; 개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다.
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2">-</span>
                      <span>
                        <strong>Chrome:</strong> 웹브라우저 우측 상단의 아이콘 선택 &gt; 설정 선택
                        &gt; 화면 하단의 고급 설정 표시 선택 &gt; 개인정보 섹션의 콘텐츠 설정 &gt;
                        쿠키 섹션에서 직접 설정
                      </span>
                    </li>
                    <li className="flex items-start">
                      <span className="mr-2">-</span>
                      <span>
                        단, 이용자가 쿠키 저장을 거부할 경우 서비스 이용에 어려움이 발생할 수
                        있습니다.
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </section>

            {/* Article 9 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 9조 이용자 및 법정대리인의 권리와 그 행사방법
              </h2>

              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    이용자 및 법정대리인은 언제든지 등록되어 있는 자신 혹은 만 14세 미만 아동의
                    개인정보를 조회하거나 수정할 수 있으며, 가입해지를 요청할 수도 있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    {`이용자 혹은 만 14세 미만 아동의 개인정보 조회/수정 또는 가입해지를 위해서는
                    "정보수정"에서 조회, 수정 및 탈퇴가 가능합니다.`}
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    {`회사는 이용자의 요청에 의해 해지 또는 삭제된 개인정보를 "제 4조 개인정보의 보유
                    및 이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수
                    없도록 처리하고 있습니다.`}
                  </span>
                </li>
              </ul>
            </section>

            {/* Article 10 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 10조 개인정보의 안전성 확보 조치
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 개인정보의 안정성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-3 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>개인정보 취급 직원의 최소화 및 교육:</strong> 개인정보를 취급하는 직원을
                    지정하고 담당자에 한정시켜 최소화하여 개인정보를 관리하는 대책을 시행하고
                    있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>해킹 등에 대비한 기술적 대책:</strong> 회사는 해킹이나 컴퓨터 바이러스
                    등에 의한 개인정보 유출 및 훼손을 막기 위하여 보안프로그램을 설치하고 주기적인
                    갱신점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고
                    기술적/물리적으로 감시 및 차단하고 있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>개인정보의 암호화:</strong> 이용자의 개인정보는 비밀번호는 암호화 되어
                    저장 및 관리되고 있어, 본인만이 알 수 있으며 중요한 데이터는 파일 및 전송
                    데이터를 암호화하거나 파일 잠금 기능을 사용하는 등의 별도 보안기능을 사용하고
                    있습니다.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    <strong>개인정보에 대한 접근 제한:</strong> 개인정보를 처리하는
                    데이터베이스시스템에 대한 접근권한의 부여, 변경, 말소를 통하여 개인정보에 대한
                    접근통제를 위하여 필요한 조치를 하고 있으며 침입차단시스템을 이용하여
                    외부로부터의 무단 접근을 통제하고 있습니다.
                  </span>
                </li>
              </ul>
            </section>

            {/* Article 11 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 11조 개인정보 관리 책임자
              </h2>
              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한
                정보주체의 불만처리 등을 위하여 아래와 같이 개인정보 보호 책임자를 지정하고
                있습니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-2 ml-4 mb-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>담당부서: 퀘스토피아 관리팀</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>개인정보관리책임자: 송만철</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>이메일: admin@questophia.com</span>
                </li>
              </ul>

              <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                회원은 회사 및 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리,
                피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 기타
                개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.
              </p>

              <ul className="text-sm text-gray-600 space-y-2 ml-4">
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>
                    개인정보 침해신고센터 (https://privacy.kisa.or.kr/kor/main.jsp / 국번없이 118)
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>대검찰청 인터넷범죄수사센터 (http://www.spo.go.kr / 02-3480-2000)</span>
                </li>
                <li className="flex items-start">
                  <span className="mr-2">-</span>
                  <span>경찰청 사이버안전국(http://cyberbureau.police.go.kr / 국번없이 182)</span>
                </li>
              </ul>
            </section>

            {/* Article 12 */}
            <section className="mb-8">
              <h2 className="text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-200">
                제 12조 개정 전 고지 의무
              </h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                상기 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가,
                삭제 및 정정이 있는 경우에는 변경사항의 시행 최소 7일 전부터 공지사항을 통하여
                고지합니다. 본 정책은 2025년 8월 15일부터 시행됩니다.
              </p>
            </section>

            {/* Footer */}
            <footer className="border-t border-gray-200 pt-6 mt-8">
              <div className="text-center text-sm text-gray-600 space-y-1">
                <p>(주)퀘스토피아 | 대표 : 송만철 | 개인정보 관리 책임자 : 송만철</p>
                <p>주소 : 서울시 강남구 영동대로 602, 6층 K267(삼성동, 삼성미켈란107)</p>
                <p>사업자등록번호 : 467-87-03443</p>
              </div>
            </footer>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
